module.exports = __webpack_public_path__ + "img/mercurialeSection3.f9a4fb1a.png";